module.exports = __webpack_public_path__ + "fonts/e741f29c-bc18-4343-bff3-db2465a0be3e.213e327c.ttf";